// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TDrq","colBig":"styles_colBig__2XQgh","colSmall":"styles_colSmall__2Gq-P"};